import React, { Component } from 'react'
import { connect } from 'react-redux'
import UserActions from '../../actions/user/user-actions'
import './login-cp.css'
// import CheckBoxCP from '../checkBox/CheckBoxCP'

class LoginCP extends Component {
  constructor () {
    super()
    this.state = {
      email: '',
      password: '',
    }

    this.onInputChange = this.onInputChange.bind(this)
    this.onLogin = this.onLogin.bind(this)
  }

  // componentDidMount() {}

  render () {
    return (
      <div className='login-contain'>
        <div className='login-content'>
          <div className='spacerEle'>
            {this.props.loginResponse} &nbsp;
          </div>

          <form onSubmit={this.onLogin}>
            <div className='spacerEle'>
              email: <input type='text' name='emailInput' className='bcioInput' 
              value={this.state.email} onChange={(event => this.onInputChange('email', event))} 
              disabled={this.props.isLoggingIn} />
            </div>
            <div className='spacerEle'>
              password: <input type='password' name='passwordInput' className='bcioInput'
              value={this.state.password} onChange={(event => this.onInputChange('password', event))} 
              disabled={this.props.isLoggingIn} />
            </div>
            <div className='spacerSection'></div>
            <div className='spacerEle'>
              <button className='bcioButton' role='' onClick={this.onLogin} disabled={this.props.isLoggingIn} >Login</button>
            </div>
          </form>

          <div className='spacerEle'>
            <a onClick={() => this.onForgotPW()}>Forgot Password</a>
          </div>
          { /*
          // for future
          
          <div className='spacerEle'>
            <div className='bcioInputCircle'>
              <div className='bcioCheckmark'></div>
            </div> Make This A Component
          </div>
          <CheckBoxCP className='spacerEle' onClick={(checked, event) => {console.log(checked)}} /> Label
          */ }
        </div>
      </div>
    )
  }

  onInputChange (prop, event) {
    var newState = {}
    newState[prop] = event.target.value
    this.setState(newState)
  }

  onLogin (event) {
    event.preventDefault()
    event.stopPropagation()
    if (this.props.isLoggingIn) return
    this.props.login(this.state.email, this.state.password)
  }

  onForgotPW () {
    console.log('lets reset')
    this.props.requestPwReset(this.state.email)
  }
}

const mapStateToProps = (state) => {
  return {
    isLoggingIn: state.user.isLoggingIn,
    loginResponse: state.user.loginResponse,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    login: (email, password) => dispatch(UserActions.login(email, password)),
    requestPwReset: (email) => dispatch(UserActions.requestPwReset(email)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginCP)
